import { render, staticRenderFns } from "./TieBreakCriteria.html?vue&type=template&id=a246c116&external"
import script from "./TieBreakCriteria.ts?vue&type=script&lang=ts&external"
export * from "./TieBreakCriteria.ts?vue&type=script&lang=ts&external"
import style0 from "./TieBreakCriteria.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports